document.addEventListener('DOMContentLoaded', () => {
  document.querySelector('[summary-btn]')?.addEventListener('click', () => {
    document.querySelector('byc-summary')?.open();
  });
  document.querySelector('[position-reset]')?.addEventListener('click', () => {
    document.querySelector('byc-capsule')?.resetPosition();
  });
  document.querySelector('[erase-settings]')?.addEventListener('click', () => {
    document.querySelector('byc-capsule')?.eraseAll();
    document.querySelector('byc-controls')?._eraseAll?.();
  });

  // ── Quote button: validate before opening ─────────────────────
  const quoteBtn = document.querySelector('[quote-btn]');
  if (quoteBtn) {
    // Start disabled — nothing is selected yet.
    // quoteBtn.setAttribute('disabled', '');
    // quoteBtn.setAttribute('aria-disabled', 'true');

    // Listen for validation updates fired by BycControls._notifySummary().
    document.addEventListener('byc:validation-change', (e) => {
      const errors = e.detail ?? [];
      const valid  = errors.length === 0;
      // quoteBtn.toggleAttribute('disabled', !valid);
      // quoteBtn.setAttribute('aria-disabled', String(!valid));
    });

    quoteBtn.addEventListener('click', () => {
      const controls = document.querySelector('byc-controls');
      const errors   = controls?._getValidationErrors?.() ?? [];
      if (errors.length) {
        bycShowValidationToast(errors);
        return;
      }
      document.querySelector('byc-quote-modal')?.open();
    });
  }
});

function bycShowValidationToast(errors) {
  document.querySelector('.byc-validation-toast')?.remove();

  const toast = document.createElement('div');
  toast.className = 'byc-validation-toast';
  toast.setAttribute('role', 'alert');
  toast.innerHTML = errors.map((e) => `<p>${e}</p>`).join('');
  document.body.appendChild(toast);

  requestAnimationFrame(() => toast.classList.add('is-visible'));

  setTimeout(() => {
    toast.classList.remove('is-visible');
    toast.addEventListener('transitionend', () => toast.remove(), { once: true });
  }, 4000);
}
